import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class JWTHandlerService {
  jwt: JwtHelperService;

  constructor() {
    this.jwt = new JwtHelperService();
  }

  decode(token: string) {
    return this.jwt.decodeToken(token);
  }

  isExpired(token: string) {
    return this.jwt.isTokenExpired(token);
  }
}
